<template>
  <div></div>

</template>

<script>

export default {

}
</script>
<style scoped="scoped" lang="scss">
.mylive {
  height: 100%;
}
ul,
li {
  padding: 0;
  margin: 0;
  list-style: none;
}
.modal-header{
  border: 1px solid  red;
}
 .modal-footer{
  width: 100%;
  background: #FFFFFF;
  padding: 0;
  border: none;
  display: flex;
  justify-content: center;
}
.modalShow-center{
  text-align: center;
  color: #666666;
  h6{
    margin-top: 1.25rem;
  }
}
#myvidio {
  width: 100%;
  height: 100%;
  video {
  }
}

.container-fluid {
  padding: 0;
  height: 100%;
  .user-actions {
    width: 100%;
    height: 4rem;
    display: flex;
    justify-content: space-between;
    user-select: none;
    .actions-left {
      display: flex;
      width: 80%;
      justify-content: flex-end;
      align-items: center;
      .volume {
        margin-right: 5rem;
        display: flex;
        align-items: center;
        cursor: pointer;
        .progress {
          width: 8rem;
          height: 0.3rem;
        }
        img {
          width: 1.6rem;
          height: 1.2rem;
        }
      }
      img {
        width: 1.4rem;
        height: 1.4rem;
        margin-right: 1.4rem;
      }
    }
    .actions-right {
      width: 20%;
      overflow: hidden;
      position: relative;
      .interaction {
        display: flex;
        width: calc(200% + 34px);
        height: 100%;
        position: absolute;
        left: 0%;
        top: 0%;
        transition: all 0.3s;
        .chat-input {
          width: 50%;
          height: 100%;
          background: #f3f3f3;
          display: flex;
          justify-content: center;
          align-items: center;
          input {
            width: calc(100% - 8rem);
            height: 2rem;
            background: #ffffff;
            border: 0px solid #aaaaaa;
            margin-right: 1rem;
            padding-left: 0.5rem;
            outline: none;
            font-size: 1rem;
          }
          button {
            width: 4rem;
            height: 2rem;
            background: #fd9800;
            border-radius: 0;
            color: #ffffff;
            font-size: 1rem;
            outline: #00ff00;
            border: none;
          }
        }
        .lianmai {
          width: 50%;
          height: 100%;
          line-height: 4rem;
          color: #ffffff;
          font-size: 1rem;
        }
      }
    }
  }
  .live-content {
    display: flex;
    justify-content: space-between;
    height: calc(100% - 250px);
    .content-left {
      width: calc(100% - 20%);
      height: 100%;
      background-color: #000000;
      position: relative;
      .lottie_box {
        position: absolute;
        width: 12.5rem;
        height: 10.5rem;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        font-size: 0.825rem;
        color: #ffffff;
      }
    }
    .content-right {
      width: 20%;
      height: 100%;

      background-color: #f3f3f3;
      position: relative;
      overflow: hidden;
      .panel {
        width: calc(200% + 34px);
        height: 90%;
        display: flex;
        justify-content: space-between;
        position: absolute;
        transition: all 0.3s;
        top: 10%;
        left: 0;
        ul {
          width: 100%;
          height: 100%;
          overflow-y: scroll;
        }
        .lianmai li {
          width: 100%;
          display: flex;
          padding: 0 0.67rem;
          margin-bottom: 1.1rem;
          justify-content: space-between;
          align-items: center;
          .mute {
            font-size: 0.55rem;
            color: #ffffff;
            background: #aaaaaa;
            width: 2.4rem;
            border-radius: 0.3rem;
          }
          .online{
               background: #fd9800;
          }
          .lianmai-content {
            display: flex;
            width: calc(100% - 2rem);
            img {
              width: 3rem;
              height: 3rem;
              border-radius: 50%;
              object-fit: cover;
              margin-right: 0.8rem;
            }
            div {
              width: 100%;
              display: flex;
              align-items: center;
              div {
                font-size: 1.2rem;
                color: #1a1a1a;
              }
              span {
                margin-left: 0.45rem;
              }
            }
          }
          img {
            width: 1.6rem;
            height: 1.2rem;
          }
        }
        .chant-teacher {
          width: 2.37rem;
          height: 1.09rem;
          background: #fd9800;
          border-radius: 3px;
          font-size: 0.63rem;
          line-height: 1.09rem;
          color: #ffffff;
        }
        .chant li {
          width: 100%;
          display: flex;
          padding: 0 0.67rem;
          margin-bottom: 1.1rem;
          .chant-content {
            width: calc(100% - 2.67rem);
            color: #aaaaaa;
            font-size: 0.8rem;
            text-align: left;
            span {
              color: #1a1a1a;
              margin: 0 0.5rem 0 0.3rem;
            }
          }
        }
      }
      .cl-top {
        width: 100%;
        height: 10%;
        background-color: #f3f3f3;
        .cl-bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: calc(100% - 2px);
          cursor: pointer;
          user-select: none;
          div {
            width: 50%;
            font-size: 1.11rem;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #f3f3f3;
          }
          .cl-top-active {
            color: #fd9800;
          }
        }
        .cl-heng {
          width: 100%;
          height: 2px;
          position: relative;
          div {
            position: absolute;
            width: 50%;
            height: 2px;
            background-color: #fd9800;
            left: 0;
            transition: all 0.3s;
          }
        }
      }
    }
  }

  .b-title {
    width: 100%;
    height: 4.4rem;
    background: #f3f3f3;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1.67rem;
    font-size: 1.11rem;
    color: #1a1a1a;
    .live-status {
      font-size: 0.89rem;
      color: #ffffff;
      background: #fd9800;
      padding: 0.39rem 0.89rem;
      border-radius: 0.4rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/livebroadcast/live.vue